import DailyTotalChart from './DailyTotalChart'

const FluidsOverview = () => (
  <DailyTotalChart
    type="fluids_in"
    title="Fluids Consumed (ml)"
    link="fluids"
    heatmapRanges={{
      low: 1000,
      medium: 1500,
      high: 2000,
      veryHigh: 2500
    }}
  />
)

export default FluidsOverview
